import { Component } from '@angular/core';
import { Istage } from 'src/framework/Istage';
import { DecoderLayoutComponent } from '../core/decoder.layout.component';

@Component({
    selector: 'app-decoderlayoutdesktop',
    templateUrl: './decoder.layout.desktop.component.html',
    styleUrls: ['../css/decoder.layout.desktop.component.scss'],
    standalone: false
})
export class DecoderLayoutDesktopComponent extends DecoderLayoutComponent {
  layoutdataDesktop: Istage = {
    stageWidth: 1280,
    stageHeight: 720,
    stageLeft: 0,
    stageTop: 0,
    stageZ: 999,
    position: 'absolute',
    overflow: 'hidden',
    name: 'updatescale',
  };

  constructor() {
    super();
  }
  ngOnDestroy() {
    delete this.layoutdataDesktop;
  }
}
